import {  Avatar } from '@mui/material';
import styled from 'styled-components';

const style = {
  tabelCell: {
    zIndex: '0',
    position: 'relative',
  },
  tableRow: {
    cursor: 'pointer',
  },
  tableCell: {
    sx: {
      maxWidth: 150,
    },
  },
  profileCell: {
    sx: {
      maxWidth: 200,
    },
  },
  dateCell: {
    sx: {
      width: 150,
    },
  },
  menuCell: {
    sx: {
      width: 10,
    },
  },
  columnWight: {
    fontWeight: 500,
  },
  blockCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  gapBlock: {
    gap: '10px',
  },
  box: {
    sx: {
      display: 'flex',

    },
  },
  dots: {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '5px',
      '&: hover': {
        borderRadius: '50%',
        backgroundColor: 'rgba(80, 72, 229, 0.08)',
      },
    },
    fontSize: '25px',
    '&: hover': {
      backgroundColor: 'rgba(80, 72, 229, 0.08)',
      borderRadius: '50%',
    },
  },
  'MuiTableRow-root': {
    '&: hover': {
      backgroundColor: 'rgba(80, 72, 229, 0.08)',
    },
  },
  sizeCell: {
    small: {
      width: '100%',
    },
  },
} as const;

export const WrapperBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const BlockCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const ImageProfile = styled(Avatar).attrs((props) => ({
  src: props.src,
  alt: props.alt,
}))`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #6B7280;
`;

export default style;
